export default __webpack_public_path__ + "static/087-e004503532e1adb6bcdd43ec49930622.jpg";